export default __webpack_public_path__ + "static/media/Letter S.e9ceaf80.mov";